import { piwikPush } from './PiwikPush';

/**
 * @see https://piwik.pro/blog/event-tracking-ultimate-guide/
 */
export type TrackEvent = {
   /**
    * Describes the type of events you want to track.
    * For example, Link Clicks, Videos, Outbound Links, and Form Events.
    */
   eventCategory: string;
   /**
    * The specific action that is taken.
    * For example, with a Video category, you might have a Play, Pause and Complete action.
    */
   eventAction: string;
   /**
    * Usually the title of the element that is being interacted with, to aid with analysis.
    * For example, it could be the name of a Video that was played or the specific
    * form that is being submitted.
    */
   eventName?: string;
   /**
    * A numeric value and is often added dynamically. It could be the cost of a
    * product that is added to a cart, or the completion percentage of a video.
    */
   eventValue?: number;
};

/**
 * @see https://piwik.pro/blog/event-tracking-ultimate-guide/
 * @example
 * const TrackingBrochureDownloads = {
 *   EventCategory: 'Downloads',
 *   EventAction: 'PDF Brochure Download',
 *   EventName: 'MyBrochure'
 * }
 * @example
 * const TrackingUserReviews = {
 *   EventCategory: 'Reviews'
 *   EventAction: 'Published Matomo Review'
 *   EventValue: 10
 * }
 */
export const trackEventInPiwik = (trackData: TrackEvent) => {
   piwikPush([
      'trackEvent',
      trackData.eventCategory,
      trackData.eventAction,
      trackData.eventName,
      trackData.eventValue,
   ]);
};
